export const HTML5_PLAYER: PlayerType = 'html5';
export const NOT_SUPPORTED: PlayerType = 'NOT_SUPPORTED';

export type PlayerType = 'html5' | 'NOT_SUPPORTED' | null;
